module.exports = __webpack_public_path__ + "img/am.7edfaa28.png";